import { localDate } from './format';

// Nach jeder Absage: Wie geht es mit dem Lead weiter (Dominik 13.10.2026)? Ohne Entscheidung blieb der Lead bisher still in der
// Akquise – auch wenn der Kunde schon einen Makler hatte.
export type CancelNextValue = 'REBOOK' | 'LATER' | 'NOT_INTERESTED' | 'ACQUISITION';

export const cancelNextOptions: readonly { value: CancelNextValue; label: string; hint: string }[] = [
  { value: 'REBOOK', label: 'Neuer Termin', hint: 'Der Terminierer vereinbart einen neuen Termin' },
  { value: 'LATER', label: 'Später erneut anfragen', hint: 'Wiedervorlage für den Terminierer zum Datum' },
  { value: 'NOT_INTERESTED', label: 'Kein Interesse', hint: 'Der Lead wird abgeschlossen' },
  { value: 'ACQUISITION', label: 'Weiter in der Akquise', hint: 'Der Lead bleibt in Bearbeitung' },
];

// inMonths: Datum (JJJJ-MM-TT) in n Monaten – Vorbelegung für „später erneut anfragen“ (ein Maklerauftrag läuft oft 6 Monate).
export function inMonths(n: number, from: Date = new Date()): string {
  const d = new Date(from);
  d.setMonth(d.getMonth() + n);
  return localDate(d);
}

export const cancelNextComplete = (next?: string, laterDate?: string) => !!next && (next !== 'LATER' || !!laterDate);
